import { ApiResponse, TokenData, Divisions } from '../models';
import * as http from './http';
import ApiService from './service';

export class DivisionsUnderCompany extends ApiService {
  public async loadAllDivisions() {
    const url = `${this.apiDomain}/api/division`;

    const resposne = await http.get<ApiResponse<Divisions[]>>(url, this.store);
    return resposne?.data?.data;
  }
  public async updateDivisions(data: Divisions, id?: string) {
    const url = `${this.apiDomain}/api/division/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  
  public async createDivisions(data: Divisions) {
    const url = `${this.apiDomain}/api/division`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteDivisions(id?: string) {
    const url = `${this.apiDomain}/api/division/${id}`;

    const response = await http.remove<ApiResponse<Divisions>>(url, this.store);
    return response.data;
  }
}
